/* Funny Mask: Clarity follows Shopify Customer Privacy permissions. */
(function () {
  if (window.__funnyMaskClarity) return;
  window.__funnyMaskClarity = true;
  var loaded = false;
  function sync() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var analytics = privacy.analyticsProcessingAllowed();
    var ads = privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    if (!analytics && !loaded) return;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: ads ? 'granted' : 'denied'
    });
    if (!loaded) {
      loaded = true;
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/yv86klz24n';
      script.id = 'funny-mask-clarity-tag';
      document.head.appendChild(script);
    }
  }
  document.addEventListener('visitorConsentCollected', sync);
  function init() {
    if (!window.Shopify) return;
    if (window.Shopify.customerPrivacy) sync();
    else if (window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) {
        if (!error) sync();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
